import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, StarIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
import { PriceDisplay } from './PriceDisplay';
import { bonuses, valueStack, priceFraming, PRICES } from '../data/content';
const bonusTotal = bonuses.reduce((sum, bonus) => sum + bonus.value, 0);
export function Bonuses() {
  return <section className="w-full bg-cream-deep px-5 py-14 sm:px-8 sm:py-20" data-id="element-22" data-mp="frtn3jr8k6o5">
      <div className="mx-auto max-w-2xl" data-id="element-23" data-mp="1t3n9wd17sw3">
        <h2 className="text-center font-display text-2xl font-bold leading-tight text-plum sm:text-3xl" data-id="element-24" data-mp="5vqmwjfy2i3u">
          Accedé a 3 Bonos Exclusivos de Regalo
        </h2>
        <div className="mt-10 space-y-6" data-id="element-25" data-mp="3o3pt21d21ywx">
          {bonuses.map((bonus, index) => <motion.article key={bonus.title} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-60px'
        }} transition={{
          duration: 0.3,
          delay: index * 0.05,
          ease: [0.23, 1, 0.32, 1]
        }} className="overflow-hidden rounded-2xl border-2 border-gold/60 bg-cream p-5 shadow-sm sm:p-6" data-id="element-26" data-mp="3t0ycs6duqb0a" data-mpi={index}>
              <div className="overflow-hidden rounded-xl bg-cream-deep" data-id="element-27" data-mp="3r6qk2rszmol9">
                <img src={bonus.image} alt={`Vista previa del ${bonus.title}`} className="mx-auto h-52 w-full object-cover" loading="lazy" data-id="element-28" data-mp="3r5ym5abx4ert" />
              </div>
              <h3 className="mt-5 font-display text-lg font-bold leading-snug text-plum" data-id="element-29" data-mp="2uh0q7osfmat2">
                {bonus.label} — {bonus.title}
              </h3>
              <p className="mt-2 font-sans text-sm leading-relaxed text-plum-soft" data-id="element-30" data-mp="38e5txi4oaxl5">
                {bonus.description}
              </p>
              <ul className="mt-4 space-y-2" data-id="element-31" data-mp="nprn5h4g75pd">
                {bonus.bullets.map(bullet => <li key={bullet} className="flex items-start gap-2.5" data-id="element-32" data-mp="ir6rlv055a79">
                    <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-sage" strokeWidth={3} aria-hidden="true" data-id="element-33" data-mp="itav4bu4o770" />
                    <span className="font-sans text-sm leading-relaxed text-plum" data-id="element-34" data-mp="3hju9r3dxsfl6">{bullet}</span>
                  </li>)}
              </ul>
              <div className="mt-5 flex items-center justify-center gap-3 rounded-xl bg-gold/15 px-4 py-3" data-id="element-35" data-mp="3qheb0cbsubvs">
                <span className="font-sans text-sm text-plum-soft line-through" data-id="element-36" data-mp="2ttzwikppgp0e">
                  Valor: <PriceDisplay amount={bonus.value} data-id="element-37" data-mp="2xutkfe35e3ta" />
                </span>
                <span className="font-sans text-sm font-black uppercase tracking-wider text-terracotta-dark" data-id="element-38" data-mp="32sleadncs004">
                  ¡Hoy gratis!
                </span>
              </div>
            </motion.article>)}
        </div>

        <div className="mt-8 rounded-2xl border-2 border-plum bg-plum p-6 text-center text-cream" data-id="element-39" data-mp="2a3wgooliact4">
          <p className="font-sans text-xs font-bold uppercase tracking-[0.16em] text-gold" data-id="element-40" data-mp="2f1y1pf2hsm78">
            Esto es todo lo que te llevás hoy
          </p>
          <ul className="mx-auto mt-5 max-w-md space-y-2.5 text-left" data-id="element-41" data-mp="22kevl6sm5eug">
            {valueStack.map(item => <li key={item.label} className="flex items-baseline justify-between gap-4 border-b border-cream/10 pb-2.5 font-sans text-sm" data-id="element-42" data-mp="1xl28qm1qs7rv">
                <span className="text-cream/85" data-id="element-43" data-mp="1olnm5xop4hcn">{item.label}</span>
                <PriceDisplay amount={item.value} className="shrink-0 font-semibold text-cream/60 line-through" data-id="element-44" data-mp="1omyoru6enj26" />
              </li>)}
          </ul>
          <div className="mx-auto mt-4 flex max-w-md items-baseline justify-between gap-4" data-id="element-45" data-mp="19w9c0ndapvw7">
            <span className="font-sans text-sm font-bold uppercase tracking-wider text-cream/80" data-id="element-46" data-mp="19ueqb6u79zr2">
              Valor total
            </span>
            <PriceDisplay amount={PRICES.totalValue} className="font-display text-2xl font-black text-cream/70 line-through decoration-terracotta decoration-4" data-id="element-47" data-mp="10wm6pqhg45xv" />
          </div>
          <p className="mx-auto mt-5 max-w-md border-t border-cream/20 pt-5 font-sans text-xs font-bold uppercase tracking-[0.16em] text-gold" data-id="element-48" data-mp="34yw77x4r8a48">
            Hoy pagás solo
          </p>
          <p className="font-display text-5xl font-black leading-none text-cream" data-id="element-49" data-mp="2w62f2z47lg8y">
            <PriceDisplay amount={PRICES.today} data-id="element-50" data-mp="2h9k0d3wwge53" />
          </p>
          <p className="mt-3 font-sans text-sm text-cream/70" data-id="element-51" data-mp="2hc6751byupm9">
            Guía <PriceDisplay amount={PRICES.guide} data-id="element-52" data-mp="2mahgzc29h04h" /> + 3 bonos{' '}
            <PriceDisplay amount={bonusTotal} data-id="element-53" data-mp="289wyyi4678c1" /> ={' '}
            <PriceDisplay amount={PRICES.totalValue} data-id="element-54" data-mp="28b7yg5ql1txc" /> — hoy, un solo pago de{' '}
            <PriceDisplay amount={PRICES.today} className="font-bold text-cream" data-id="element-55" data-mp="2d8i0ckv5ry22" />
          </p>
          <p className="mt-4 font-sans text-sm text-cream/70" data-id="element-56" data-mp="6ibkob5agd9j">{priceFraming.comparisonShort}.</p>
        </div>

        <div className="mt-7 flex justify-center" data-id="element-57" data-mp="besglriqbvx6">
          <CTAButton size="lg" className="w-full" data-id="element-58" data-mp="lk0hj1s6jsd0">
            Agregar al carrito
          </CTAButton>
        </div>
        <p className="mt-3 text-center font-sans text-xs font-semibold uppercase tracking-[0.12em] text-plum-soft" data-id="element-59" data-mp="gn08qj3y4bi7">
          Acceso inmediato · Pago único · Garantía 7 días
        </p>
        <div className="mt-2 flex items-center justify-center gap-2" data-id="element-60" data-mp="pm59zx6w6iy2">
          <div className="flex" aria-hidden="true" data-id="element-61" data-mp="14b1czfu3d5rt">
            {[0, 1, 2, 3, 4].map(i => <StarIcon key={i} className="h-3.5 w-3.5 fill-gold text-gold" data-id="element-62" data-mp="zc6teboavd6n" />)}
          </div>
          <span className="font-sans text-xs font-semibold text-plum-soft" data-id="element-63" data-mp="1dbpr0ajhj64p">
            4.9/5 · +10.000 mujeres
          </span>
        </div>
      </div>
    </section>;
}